import { useEffect, useMemo, useState } from "react"
import { Column, FieldType, FieldValue, Link, Section, Table } from "../../../../../features/ui"
import { CreditPaymentOperationItem } from "../../../state/types"
import { SaleOperation, saleOperationHelpers, useSaleOperationLoaders } from "../../../../sales"
import { useDescribeHooks } from "../../../../../features/data-types"
import { TableName } from "../../../../../tables"
import { RoutePath, useRoutesHooks } from "../../../../../features/routes"
import { useNavigate } from "react-router-dom"

type Props = {
  operationItems: CreditPaymentOperationItem[]
}

export const CreditPaymentOperationItemsTable = (props: Props) => {
  const { operationItems } = props

  const [operations, setOperations] = useState<SaleOperation[]>([])
  
  const { getTable } = saleOperationHelpers
  const { describe } = useDescribeHooks()
  const { getRoutePath } = useRoutesHooks()
  const navigate = useNavigate()

  const saleOperationLoaders = useSaleOperationLoaders()

  useEffect(() => {
    const operationIds = operationItems.map(item => item.operationId)
    saleOperationLoaders().loadSaleOperations(operationIds).then(setOperations)
  }, [operationItems])

  const icon = (table: TableName) => {
    const icons = new Map<TableName, string>()
      .set(TableName.SALE_ORDERS, 'tags')
      .set(TableName.HOARD_ORDERS, 'layers')
    return icons.get(table)
  }

  const goToOperation = (table: TableName, operationId: string) => () => {
    const routePaths = new Map<TableName, RoutePath>()
      .set(TableName.SALE_ORDERS, RoutePath.SALES)
      .set(TableName.HOARD_ORDERS, RoutePath.HOARDS)
    const tablePath = routePaths.get(table)!
    navigate(getRoutePath(tablePath, operationId))
  }

  const rows = useMemo(() => operations.length > 0 ? operationItems : [], [operations, operationItems])

  const pricesColumns: Column[] = [
    {
      name: 'operationId',
      type: FieldType.TEXT,
      label: 'Operación',
      render: (value?: FieldValue) => {
        const operation = operations.find(operation => operation.id === value)!
        const table = getTable(operation)
        const label = describe(table, operation)
        return <Link
            text={label}
            icon={icon(table)}
            kind="primary"
            onClick={goToOperation(table, value! as string)}
        />
      }
    },
    {
      name: 'amount',
      type: FieldType.PRICE,
      label: 'Monto Cancelado'
    }
  ]

  return (
    <Section id="operation-items-table">
      <Table
        columns={pricesColumns}
        rows={rows}
        rowId="operationId"
        readOnly
      />
    </Section>
  )
}
